import './PageLastUpdated.scss';

export { default } from './PageLastUpdated';
